export default {"src":"/_next/static/media/starbucks-logo.9574b4b9.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};